
import {
  computed,
  defineComponent,
  h,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import {
  AdminTableLayout,
  DatePicker,
  DefaultOptionSelect,
  ReportTable,
} from "@/components/Common";

import moment from "dayjs";

import {
  useDynamicDialog,
  usePagination,
  useReportTableShowColumn,
} from "@/hooks";

import { tableColumn } from "./billistColum";

import {
  AccountPreviewQryExe,
  CheckAccountBill,
  GetReconcilerField,
  QueryAccountBillList,
  ConfirmationSignatureType,
  GetProjectCustomerInfo,
} from "@/api-server/modules/defaultServer";
import { formatLimitMonth } from "@/utils/formatter";
import { RootState } from "@/@types/store";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElLink, ElMessage, ElMessageBox } from "element-plus";
import { zcatPoint } from "@/utils/utilFuns";
import { ColumnList } from "@/@types/common";

interface DialogPreview {
  show: boolean;
  urls: string[];
}
interface contractProject {
  id: number;
  customerCode: string;
  customerName: string;
}
export default defineComponent({
  name: "BillList",
  components: {
    AdminTableLayout,
    DatePicker,
    DefaultOptionSelect,
    ReportTable,
  },

  setup() {
    const store = useStore<RootState>();
    const router = useRouter();
    const { getModelUUID, openModel } = useDynamicDialog();

    const siteAffirmStatus = computed(
      () => store.getters["bill/siteAffirmStatus"]
    );
    const affirmStatus = computed(() => store.getters["bill/affirmStatus"]);
    const formData = reactive({
      time: [moment().format("YYYYMM"), moment().format("YYYYMM")],
      affirmStatus: "",
      siteId: "",
      customerId: "",
      contractProjectId: "",
    });
    const accountWithSite = computed(
      () => store.getters["bill/accountWithSite"]
    );
    const siteList = computed(() => {
      const objData =
        accountWithSite.value.find((v: any) => v.value === formData.customerId)
          ?.childEnum || {};
      return Object.keys(objData).map((value) => {
        return {
          key: objData[value],
          value,
        };
      });
    });
    const contractProjectList = ref<any>([]);
    const preview = ref<DialogPreview>({
      show: false,
      urls: [],
    });

    const calendarTime = ref<Date[]>([]);
    const handleCalendarChange = (dates: Date[]) => {
      calendarTime.value = dates;
    };
    console.log((window as any).$calIsChatFreelyVersion);
    watch(
      () => siteList.value,
      () => {
        formData.siteId = siteList.value[0]?.value || "";
      },
      { immediate: true }
    );
    watch(
      () => formData.customerId,
      () => {
        formData.contractProjectId = "";
        getContractProject(Number(formData.customerId));
      }
    );
    const { showTableColumn } = useReportTableShowColumn(tableColumn);

    const serarchRules = {
      time: [
        { required: true, message: "请选择结款日期", trigger: "blur" },
        {
          validator: (rule: any, dates: Date[], callback: any) => {
            if (
              dates &&
              moment(dates[1]).year() * 12 +
                moment(dates[1]).month() -
                moment(dates[0]).year() * 12 -
                moment(dates[0]).month() >=
                3
            ) {
              callback("查询区间不能超过三个月");
            } else {
              callback();
            }
          },
        },
      ],
      customerId: [
        { required: true, message: "请选择客户名称", trigger: "blur" },
      ],
      siteId: [{ required: true, message: "请选择网点名称", trigger: "blur" }],
    };

    const {
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      tableData,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
      errorCode,
    } = usePagination(
      QueryAccountBillList.fetch,
      formData,
      (editFormData) => {
        zcatPoint(["账单汇总", "查询"]);
        return {
          ...editFormData,
          startTime:
            editFormData.time.length > 0
              ? moment(editFormData.time[0]).format("YYYYMM")
              : undefined,
          endTime:
            editFormData.time.length > 0
              ? moment(editFormData.time[1]).format("YYYYMM")
              : undefined,
          time: undefined,
        };
      },
      {
        notMountedRequest: true,
      }
    );
    const getContractProject = async (customerId: number) => {
      if (!customerId) return;
      const {
        data: { data },
      } = await GetProjectCustomerInfo.fetch({
        customerId: customerId,
      });
      console.log("data=====", data);
      contractProjectList.value = data || [];
    };
    const handleBillDetail = (row: any) => {
      if ((window as any).$calIsChatFreelyVersion) {
        zcatPoint(["售后版-账单汇总", "账单明细"]);
        (window as any).$mRouter.push({
          path: "/chat-freely/msp/admin/bill-manager/bill-detail",
          query: {
            borrowingDate: moment(row.borrowingDate).format("YYYYMMDD"),
            accountCycle: row.accountCycle,
            customerId: row.customerId,
            contractProjectId: row.contractProjectId,
            siteId: row.siteId,
            status: row.customerCheckStatus,
            id: row.id,
          },
        });
      } else {
        zcatPoint(["账单汇总", "账单明细"]);
        router.push({
          path: "/admin/bill-manager/bill-detail",
          query: {
            borrowingDate: moment(row.borrowingDate).format("YYYYMMDD"),
            accountCycle: row.accountCycle,
            customerId: row.customerId,
            contractProjectId: row.contractProjectId,
            siteId: row.siteId,
            status: row.customerCheckStatus,
            id: row.id,
          },
        });
      }
    };

    const handleAdjustDetail = (row: any) => {
      if ((window as any).$calIsChatFreelyVersion) {
        zcatPoint(["售后版-账单汇总", "调账明细"]);
        (window as any).$mRouter.push({
          path: "/chat-freely/msp/admin/bill-manager/adjust-detail",
          query: {
            contractProjectId: row.contractProjectId,
            borrowingDate: moment(row.borrowingDate).format("YYYYMMDD"),
            accountCycle: row.accountCycle,
            customerId: row.customerId,
            siteId: row.siteId,
            status: row.customerCheckStatus,
          },
        });
      } else {
        zcatPoint(["账单汇总", "调账明细"]);
        router.push({
          path: "/admin/bill-manager/adjust-detail",
          query: {
            contractProjectId: row.contractProjectId,
            borrowingDate: moment(row.borrowingDate).format("YYYYMMDD"),
            accountCycle: row.accountCycle,
            customerId: row.customerId,
            siteId: row.siteId,
            status: row.customerCheckStatus,
          },
        });
      }
    };

    const handleSure = async (row: any) => {
      zcatPoint(["账单汇总", "账单确认"]);
      await ElMessageBox.confirm(
        row.pendingTotal > 0
          ? "您有调账申请尚未进行确认处理，确认账单号会撤销对应的调账申请，是否继续进行账单确认？"
          : "是否确认进行账单确认",
        "警告",
        {
          cancelButtonText: "取消",
          confirmButtonText: "确认",
        }
      );
      await CheckAccountBill.fetch({
        accountCycleDay: moment(row.borrowingDate).format("YYYYMMDD"),
        accountCycle: row.accountCycle,
        customerId: row.customerId,
        contractProjectId: row.contractProjectId,
        siteId: row.siteId,
      });

      if (row.accountCycle == 3) {
        row.customerCheckStatus = 1;
        handleSureSign(row);
      } else {
        await ConfirmationSignatureType.fetch({
          customerId: row.customerId,
          id: row.formData.id,
          type: 2,
        });
        requestTableData();
        ElMessage.success({ showClose: true, message: "账单确认成功" });
      }
    };

    const handlePreView = async (row: any) => {
      zcatPoint(["账单汇总", "账单预览"]);
      if (!row.accountUrl)
        return ElMessage.warning({
          showClose: true,
          message: "账单确认文件待网点上传",
        });
      const {
        data: { data },
      } = await AccountPreviewQryExe.fetch({
        id: row.id,
        url: row.accountUrl,
      });
      preview.value = {
        show: true,
        urls: [data as string],
      };
    };

    const handleSureSign = async (row: any) => {
      const uuid = await getModelUUID(
        "admin/bill-manager/bill-list/sureSignDialog"
      );
      openModel(
        uuid,
        {
          formData: {
            ...row,
            type: "1",
          },
        },
        {
          updateSuccess: () => {
            requestTableData();
          },
        }
      );
    };

    const onClosePreview = () => {
      preview.value.show = false;
    };

    const actionsHandle = ({ row }: any) => {
      return [
        h(
          ElLink as any,
          {
            type: "primary",
            style: "margin-right: 5px",
            onClick: () => handleBillDetail(row),
          },
          "账单明细"
        ),
        h(
          ElLink as any,
          {
            type: "primary",
            style: "margin-right: 5px",
            onClick: () => handleAdjustDetail(row),
          },
          "调账明细"
        ),
        row.siteCheckStatus == 0 &&
          h(
            ElLink as any,
            {
              type: "primary",
              style: "margin-right: 5px",
              onClick: () => handleSure(row),
            },
            "账单确认"
          ),
        row.siteCheckStatus == 1 &&
          row.customerCheckStatus != 1 &&
          h(
            ElLink as any,
            {
              type: "primary",
              style: "margin-right: 5px",
              onClick: () => handleSure(row),
            },
            "账单确认"
          ),
        row.siteCheckStatus == 1 &&
          row.customerCheckStatus == 1 &&
          row.accountCycle == 3 &&
          !row.signatureAddress &&
          h(
            ElLink as any,
            {
              type: "primary",
              style: "margin-right: 5px",
              onClick: () => handleSureSign(row),
            },
            "确认函签署"
          ),
      ];
    };

    return {
      formData,
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
      showTableColumn,
      tableData,
      formatLimitMonth,
      errorCode,
      siteAffirmStatus,
      affirmStatus,
      accountWithSite,
      siteList,
      handleBillDetail,
      handleAdjustDetail,
      serarchRules,
      handleSure,
      handlePreView,
      preview,
      onClosePreview,
      calendarTime,
      handleCalendarChange,
      handleSureSign,
      actionsHandle,
      contractProjectList,
    };
  },
});
